define("ember-perfect-scroll/components/perfect-scroll/template", ["exports"], function (exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = Ember.HTMLBars.template({ "id": "JOBZhOlH", "block": "[[[10,0],[15,1,[29,[[36,0]]]],[14,0,\"ps-content\"],[12],[1,\"\\n  \"],[18,1,null],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"&default\"],false,[\"eId\",\"yield\"]]", "moduleName": "ember-perfect-scroll/components/perfect-scroll/template.hbs", "isStrictMode": false });
});